import React, { useState } from 'react';
import PropTypes from 'prop-types';

/* Set Global States here. */
const defaultState = {
    modalOpen: false,
    setModalOpen: () => {},
    externalUrl: null,
    setExternalUrl: () => {},
    modalType: null,
    setModalType: () => {},
};

const AppContext = React.createContext(defaultState);

const AppProvider = ({ children }) => {
    const [modalOpen, setModalOpen] = useState(defaultState.modalOpen);
    const [url, setUrl] = useState(defaultState.externalUrl);
    const [modalType, setModalType] = useState(defaultState.modalType);

    const store = {
        modalOpen: modalOpen,
        setModalOpen: setModalOpen,
        externalUrl: url,
        setExternalUrl: setUrl,
        modalType: modalType,
        setModalType: setModalType,
    };

    return (
        <>
            <AppContext.Provider value={store}>{children}</AppContext.Provider>
        </>
    );
};

AppProvider.propTypes = {
    children: PropTypes.node,
};

export default AppContext;

export { AppProvider };
